import {Injectable} from "@angular/core";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import {Observable} from "rxjs";

import {environment} from "../../../environments/environment";

export interface HttpResult<T> {
    imageUrl?: string; //optional field
    code: HttpStatusCode;
    message: string;
    data: T;

}

export interface SnapToWinResultHolder {
    success: boolean;
    productId: number;
    path: string;
    prize: string;
    record_id: string;
}

export interface MessageInterface {
    en: string;
    zh: string;
}

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(
        private http: HttpClient
    ) {
    }

    public get<T>(endpoint: string, params?: any): Observable<HttpResult<T>> {
        return this.http.get<HttpResult<T>>(environment.api_base_url + endpoint, {
            params: params
        });
    }

    public post<T>(endpoint: string, body: any, params?: any): Observable<HttpResult<T>> {
        return this.http.post<HttpResult<T>>(environment.api_base_url + endpoint, body);
    }

    public put<T>(endpoint: string, body: any, params?: any): Observable<HttpResult<T>> {
        return this.http.put<HttpResult<T>>(environment.api_base_url + endpoint, body, {
            params
        });
    }

    public delete<T>(endpoint: string, params?: any): Observable<HttpResult<T>> {
        return this.http.delete<HttpResult<T>>(environment.api_base_url + endpoint, {
            params
        });
    }
}
